export const PALETTE = {
  skin: {
    tanned: "#E6BFA1",
    yellow: "#F2D6B3",
    pale: "#F7DCC8",
    light: "#F2C9A0",
    brown: "#C58A5A",
    darkBrown: "#8E5A33",
    black: "#5A3C2C"
  },
  hair: {
    auburn: "#8C4B32",
    black: "#1F1F1F",
    blonde: "#E2C36A",
    brown: "#5A3A22",
    pastel: "#F1A7C6",
    platinum: "#E6E1D1",
    red: "#B24A2F",
    gray: "#9AA0A6"
  },
  clothes: {
    black: "#262626",
    blue: "#2F66B5",
    gray: "#8E9399",
    heather: "#B0B4BA",
    pastel: "#F4B9A3",
    pink: "#E0A2C4",
    red: "#C54E4E",
    white: "#F5F5F5"
  },
  bg: {
    blue: "#6CC7FF",
    mint: "#BDEFE5",
    lavender: "#D9D6FF",
    peach: "#F7C7B1",
    sand: "#F0E3C6",
    gray: "#D9DEE3",
    green: "#B7E6C4",
    red: "#F2B2B2"
  },
  ui: {
    line: "#111111",
    bgSolid: "#EEF2F7"
  }
};
